import { CustomTableComponent } from 'commons/components';
import { useTranslation } from 'core/i18n/i18n';
import { SettingsTableHeaderOptionsComponent } from 'modules/settings/components/settings-table-header-options/settings-table-header-options.component';
import { useConfigurationList } from 'modules/settings/contexts/device-configuration/hooks/use-configuration-list.hook';
import { useNavigate } from 'react-router-dom';
import { SettingsDeviceRowOptions } from './components/settings-device-row-options/settings-device-row-options.component';
import { useDefaultConfigurationList } from './hooks/use-default-configuration-list.hook';
import { DeviceConfigurationInfo } from './settings-devices-configuration-list.model';
import { DeviceConfigurationTableContainer } from './settings-devices-configuration-list.style';

interface SettingsDevicesConfigurationListProps {
    scrollContainerRef?: React.RefObject<HTMLDivElement>;
}

export const SettingsDevicesConfigurationList: React.FC<SettingsDevicesConfigurationListProps> = ({
    scrollContainerRef,
}) => {
    const { t } = useTranslation();
    const { getDefaultConfig } = useDefaultConfigurationList();
    const navigate = useNavigate();

    const {
        configurations,
        isLoading,
        selectedRows,
        handleOnSelectRows,
        setSelectedRows,
        showOnlyActiveConfigs,
        setShowOnlyActiveConfig,
    } = useConfigurationList();

    const handleOnClickRow = (configId: string) => {
        const configuration = configurations.find((item) => item.id === configId);
        if (configuration) {
            navigate(configuration.id);
        }
    };

    return (
        <DeviceConfigurationTableContainer>
            <CustomTableComponent<DeviceConfigurationInfo>
                headerTitle={t('settings.devices.device-settings.device-config-list.title')}
                selectedRows={selectedRows}
                setSelectedRows={setSelectedRows}
                onSelectRow={(configurationId, event) => handleOnSelectRows(configurationId, event, configurations)}
                onClickRow={handleOnClickRow}
                totalElements={configurations.length}
                tableData={configurations}
                config={getDefaultConfig()}
                scrollContainerRef={scrollContainerRef}
                loading={isLoading}
                horizontalScroll
                emptyMessage={t('settings.devices.device-settings.device-config-list.no_config_available')}
                rowOptions={(configuration: DeviceConfigurationInfo) => [
                    <SettingsDeviceRowOptions
                        key={`settings-device-row-options-${configuration.id}`}
                        configuration={configuration}
                    />,
                ]}
                optionComponents={
                    <SettingsTableHeaderOptionsComponent
                        showOnlyActive={showOnlyActiveConfigs}
                        onShowOnlyActiveChange={setShowOnlyActiveConfig}
                        text={t('settings.devices.device-settings.device-config-list.show-inactive')}
                    />
                }
            />
        </DeviceConfigurationTableContainer>
    );
};
